import "./App.css";
import Navigations from "./Navigations/Navigations";

const App = () => {
  return <Navigations />;
};

export default App;
